/** How a setup step renders inside the Summary's step card. */
export type SolarSummaryStepMode = {
  /** Moves to the next Summary step: after a save, or with nothing changed. */
  onContinue: () => void
}

export const SUMMARY_CONTINUE_LABEL = `Continue`
export const SUMMARY_SAVE_AND_CONTINUE_LABEL = `Save & Continue`

/**
 * V1's Summary button: Continue when nothing changed, Save & Continue once the
 * seller edited the step. Saving moves on only after the save succeeds.
 */
export const SolarSummaryStepFooter = ({
  changed,
  busy,
  disabled,
  onSave,
  onContinue,
}: {
  changed: boolean
  busy: boolean
  disabled: boolean
  onSave: () => void
  onContinue: () => void
}): JSX.Element => (
  <div className="flex justify-end border-t border-border pt-5">
    <button
      type="button"
      data-testid="solar-summary-continue"
      className="rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-50"
      disabled={disabled || busy}
      onClick={changed ? onSave : onContinue}
    >
      {busy
        ? `Saving…`
        : changed
          ? SUMMARY_SAVE_AND_CONTINUE_LABEL
          : SUMMARY_CONTINUE_LABEL}
    </button>
  </div>
)
